/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Arable_Busy_Samuel_TwistInputs */

const fr_arable_busy_samuel_twist = /** @type {(inputs: Arable_Busy_Samuel_TwistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression de tous les facteurs MFA de`)
};

/**

* @param {Arable_Busy_Samuel_TwistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const arable_busy_samuel_twist = /** @type {((inputs?: Arable_Busy_Samuel_TwistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Arable_Busy_Samuel_TwistInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_arable_busy_samuel_twist(inputs)
});